(function () {
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function drawer() { return document.querySelector('cart-drawer'); }
  function sectionIds() {
    var d = drawer();
    if (d && typeof d.getSectionsToRender === 'function') return d.getSectionsToRender().map(function (s) { return s.id; });
    return ['cart-drawer', 'cart-icon-bubble'];
  }
  function post(path, body) {
    body.sections = sectionIds();
    body.sections_url = window.location.pathname;
    return fetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function render(data) {
    var d = drawer();
    if (!d || !data || !data.sections || typeof d.renderContents !== 'function') { window.location.reload(); return; }
    var empty = data.item_count === 0;
    d.classList.toggle('is-empty', empty);
    d.renderContents(data);
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('[data-bz-remove]');
    if (rm) {
      e.preventDefault();
      var updates = {};
      rm.getAttribute('data-bz-remove').split(',').forEach(function (k) { if (k) updates[k] = 0; });
      var card = rm.closest('.bzc-pack');
      if (card) card.classList.add('is-busy');
      rm.disabled = true;
      post('cart/update.js', { updates: updates }).then(render).catch(function () { window.location.reload(); });
      return;
    }
    var add = e.target.closest && e.target.closest('[data-bz-up-add]');
    if (add) {
      e.preventDefault();
      var label = add.textContent;
      add.disabled = true;
      add.textContent = 'Adding...';
      post('cart/add.js', { items: [{ id: parseInt(add.getAttribute('data-variant'), 10), quantity: 1 }] })
        .then(function (data) {
          if (data && data.status) { add.disabled = false; add.textContent = data.description ? 'Sold out' : label; return; }
          render(data);
        })
        .catch(function () { add.disabled = false; add.textContent = label; });
    }
  });
})();